import { render } from "./index.vue?vue&type=template&id=caf501b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=caf501b0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-caf501b0"

export default script